var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    class: {
      'active-menu': _vm.isSubItemsListOpened,
      'inactive-menu': !_vm.isSubItemsListOpened
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goToPageRoute(_vm.itemRoute, _vm.itemTitle);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.itemTitle) + "   "), _c('font-awesome-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.subItemList.length > 0,
      expression: "subItemList.length > 0"
    }],
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "size": "1x",
      "icon": _vm.isSubItemsListOpened ? 'chevron-down' : 'chevron-left'
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.subItemList.length > 0 && _vm.isSubItemsListOpened,
      expression: "(subItemList.length > 0) && isSubItemsListOpened"
    }],
    staticClass: "submenu-item-list-container"
  }, [_c('ul', _vm._l(_vm.subItemList, function (subItem) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: subItem.isItemVisible === undefined || subItem.isItemVisible === true,
        expression: "subItem.isItemVisible === undefined || subItem.isItemVisible === true"
      }],
      key: subItem.subItemTitle,
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.goToPageRoute(subItem.subItemRoute, null, subItem.announcmentSubject);
        }
      }
    }, [_vm._v(" " + _vm._s(subItem.subItemTitle) + " ")]);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }